import { mutator } from 'satcheljs';
import { upsertItemsForDescriptor } from '../actions/internalActions';
import { getStore } from '../store/store';
import { lockHasDescriptor } from '../query/lockHasDescriptor';
import { getCachedFunctions } from '../store/CachedFunctions';

export const upsertItemsForDescriptorMutator = mutator(upsertItemsForDescriptor, actionMessage => {
    const { key, lockId, descriptor } = actionMessage;
    const store = getStore(key);
    const lockedDescriptors = store.locks.get(lockId);
    const { containsDescriptor } = getCachedFunctions(key);

    // Add the descriptorId to the list of descriptors locked by lockId
    if (lockedDescriptors) {
        if (!lockHasDescriptor(store, lockId, descriptor, containsDescriptor)) {
            lockedDescriptors.push(descriptor.Id);
        }
    } else {
        getStore(key).locks.set(lockId, [descriptor.Id]);
    }
});
